module.exports = __webpack_public_path__ + "img/P54-en.79fd413a.png";